// extracted by mini-css-extract-plugin
module.exports = {"btn":"CreateOutlet_btn__FWlFR"};